/* eslint-disable global-require */
const base = {
  qa: require("./qa/base"),
  staging: require("./staging/base"),
  production: require("./production/base"),
  // aws environments
  "aws-int": require("./aws-int/base"),
  "aws-stg": require("./aws-stg/base"),
  "aws-prd": require("./aws-prd/base")
};

export default base;
